/* =====================================================================================
   Where a failed background load becomes visible.

   Deliberately not a red banner across the top of the page. These are partial failures on
   screens that remain usable: the Docket still shows its families when the deadline query
   fails, and taking over the whole route would be a worse outcome than a degraded panel.

   What it must do is remove the ambiguity. Before this, a failed request and an empty table
   looked the same, so "Crew is empty" could equally mean the workforce has no records or the
   query was refused. The notice names the data and gives the reason, which is the difference
   between a bug report and a diagnosis.
   ===================================================================================== */

import { useSyncExternalStore } from 'react';
import { subscribeErrors, errorSnapshot, dismissError, clearErrors } from '../lib/errors';
import './errornotices.css';

export function ErrorNotices() {
  const errors = useSyncExternalStore(subscribeErrors, errorSnapshot, errorSnapshot);
  if (!errors.length) return null;

  return (
    <div className="en-wrap" role="region" aria-label="Load failures">
      {errors.map((e) => (
        <div key={e.id} className="en" role="alert">
          <div className="en-body">
            <strong className="en-what">{e.what} could not be loaded</strong>
            {/* The reason, not a stack. The stack is on the console for whoever is debugging. */}
            <span className="en-detail">{e.detail}</span>
          </div>
          <button className="en-x" onClick={() => dismissError(e.id)}
                  aria-label={`Dismiss the ${e.what} failure`}>×</button>
        </div>
      ))}
      {errors.length > 1 && (
        <button className="en-clear" onClick={clearErrors}>Dismiss all {errors.length}</button>
      )}
    </div>
  );
}
